
<table class="rootdiv">
    <tr>
        <td><label class="input-label">Collection Name:</label></td>
        <td><app-combo-box 
            [(value)]="collectionName" 
            (valueSelect)="setCollectionName($event);" 
            (valueChange)="collectionNameChange();"
            [options]="collectionNames">
        </app-combo-box></td>
    </tr>
    <tr>
        <td><label class="input-label">Key:</label></td>
        <td><app-combo-box 
            [(value)]="key" 
            (valueSelect)="setKey($event);" 
            [options]="keys">
        </app-combo-box></td>
    </tr>
    <tr>
        <td><button mat-raised-button color="primary" (click)="uploader.click();">Open File</button></td>
        <td><label class="file-label">{{fileName}}</label></td>
    </tr>
</table>
<td><input hidden type="file" #uploader (change)="uploadFile($event)" /></td>


<div class="textdiv">
    <span class="text-wrapper" *ngIf="jsonString != ''">
        <span>
            <label class="clickable" (click)="copyText()">Stored Value <mat-icon >file_copy</mat-icon></label>
        </span>
        <textarea [ngModel]="jsonString" disabled></textarea>
    </span>
    <span class="text-wrapper" *ngIf="uploadString != ''" >
        <label>Upload Content</label>
        <textarea [ngModel]="uploadString" disabled></textarea>
    </span>
</div>

<div class="formdiv" *ngIf="uploadString != ''">
    <button class="form-btn" mat-raised-button color="primary" (click)="setApplicationData();" [disabled]='collectionName == "" || key == ""'>Upload</button>
    <button class="form-btn" mat-raised-button color="warn" (click)="cancel();">Cancel</button>
</div>